<template>
  <div>
    <div v-if="Lib.checkPower('beauty-4-ckygxsldfx',2)" class="employeeSale">
      <div class="employeeSale-top">
        <date-picker @selectDate="initGetSignSuccess" />
        <ul>
          <li v-for="(item,index) in munList" :key="index" :class="acitve==index?'employeeSale-active':''" @click="selectMun(item,index)">{{ item.name }}</li>
        </ul>
      </div>
      <!--图表-->
      <div class="bar-box">
        <h2>{{ acitve==0?'销售员工Top20（按销售额）':'劳动员工Top20（按劳动额）' }}</h2>
        <div id="barDate" style="width:1600px;height:300px;margin:0 auto"></div>
      </div>
      <!--表格-->
      <div class="employeeSale-table">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane :label="acitve==0?'员工销售明细':'员工劳动明细'" name="first">
            <!--员工销售明细-->
            <el-table v-if="acitve==0" tooltip-effect="light" :data="tableData" style="width: 100%">
              <el-table-column type="index" width="100" label="排名">
                <template slot-scope="scope">
                  {{ scope.$index*1+1 + (currentPage*1-1)*10 }}
                </template>
              </el-table-column>
              <el-table-column prop="technicianName" label="员工名称"></el-table-column>
              <el-table-column prop="itemSaleCount" label="项目销售量" sortable></el-table-column>
              <el-table-column prop="productSaleCount" label="产品销售量" sortable></el-table-column>
              <el-table-column prop="packageSaleCount" label="套餐销售量" sortable></el-table-column>
              <el-table-column prop="saleCount" sortable>
                <template slot="header" slot-scope="scope">
                  累计销售量
                  <el-tooltip v-show="scope" effect="light" :content="'累计销售量=项目销售数量+产品销售数量+套餐销售数量'" placement="right">
                    <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="saleAmount" sortable>
                <template slot="header" slot-scope="scope">
                  累计销售总额
                  <el-tooltip v-show="scope" effect="light" :content="'累计销售总额=项目销售总额+产品销售总额+套餐销售总额'" placement="right">
                    <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <!--员工劳动明细-->
            <el-table v-if="acitve==1" tooltip-effect="light" :data="tableData" style="width: 100%">
              <el-table-column type="index" width="100" label="排名">
                <template slot-scope="scope">
                  {{ scope.$index*1+1 + (currentPage*1-1)*10 }}
                </template>
              </el-table-column>
              <el-table-column prop="technicianName" label="员工名称"></el-table-column>
              <el-table-column prop="memberServeCount" label="会员劳动次数（次）" sortable></el-table-column>
              <el-table-column prop="noMemberServeCount" label="散客劳动次数（次）" sortable></el-table-column>
              <el-table-column prop="serveCount" label="累计劳动次数（次）" sortable></el-table-column>
              <el-table-column prop="serveAmount" sortable>
                <template slot="header" slot-scope="scope">
                  累计劳动总额
                  <el-tooltip v-show="scope" effect="light" :content="'累计劳动总额=会员劳动总额+散客劳动总额'" placement="right">
                    <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination v-if="tableData.length!=0" background layout="prev, pager, next" :current-page.sync="currentPage" :total="total" @current-change="handleCurrentChange"></el-pagination>
          </el-tab-pane>
        </el-tabs>
        <div class="button_group">
          <el-button size="small" @click="onExportTable">导出报表</el-button>
          <el-button size="small" @click="onPrint">打印报表</el-button>
        </div>
      </div>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>
<script>
// import echarts from 'echarts';
import * as echarts from 'echarts';
import api from '../api/index';

export default {
  data() {
    return {
      munList: [
        { index: 0, name: '销售' },
        { index: 1, name: '劳动' }
      ],
      acitve: 0, // 0：销售，1：劳动
      activeName: 'first',
      list: {},
      tableData: [],
      currentPage: 1,
      total: 0,
      myChart: '',
    };
  },
  mounted() {
  },
  methods: {
    // 切换
    selectMun(item, index) {
      this.acitve = index;
      this.initGetSignSuccess(JSON.parse(window.sessionStorage.getItem('selectDate')));
    },
    // 创建产品销售趋势柱状图
    drawProjectBar() {
      // const myChart = echarts.init(document.getElementById('barDate'));
      // 当窗口或者大小发生改变时执行resize，重新绘制图表
      this.myChart.resize();
      // window.onresize = myChart.resize;
      // 监听屏幕变化自动缩放图表
      // window.addEventListener('resize', () => { myChart.resize(); });
      // 图表名
      let name = '';
      // x轴员工名称
      let technicianNameList = '';
      // 左y轴
      let dateListOne = '';
      // 右y轴
      let dateListTow = '';
      console.log('状态', this.acitve);
      if (this.acitve === 0) {
        name = ['销售总额（元）', '销售量'];
        technicianNameList = this.list.technicianSaleRankList.map((item) => item.technicianName);
        dateListOne = this.list.technicianSaleRankList.map((item) => item.saleAmount);
        dateListTow = this.list.technicianSaleRankList.map((item) => item.saleCount);
      } else {
        name = ['劳动总额（元）', '劳动次数（次）'];
        technicianNameList = this.list.technicianServeRankList.map((item) => item.technicianName);
        dateListOne = this.list.technicianServeRankList.map((item) => item.serveAmount);
        dateListTow = this.list.technicianServeRankList.map((item) => item.serveCount);
      }
      // 基于准备好的dom，初始化echarts实例- 绘制图表
      this.myChart.setOption({
        color: ['#fe6d6c', '#339cf2'],
        legend: {
          right: '50%',
          data: name,

        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        grid: {
          left: '5%',
          right: '5%',
        },
        xAxis: {
          type: 'category',
          data: technicianNameList,
          axisLabel: {
            interval: 0,
            show: true,
            formatter(e) {
              return (e.length > 4 ? (`${e.slice(0, 4)}...`) : e);
            },
            // textStyle: {
            //   color: '#FFFFFF',
            //   fontSize: 12,
            //   lineHeight: '16px'
            // }
          },
          // triggerEvent: false, // 设置为true后，可触发事件。实现x轴文字过长，显示省略号，hover上去显示全部的功能
        },
        yAxis: [
          {
            type: 'value',
            name: name[0],
            // min: Math.min.apply(null, dateListOne),
            // max: Math.max.apply(null, dateListOne),
            axisLabel: {
              formatter: '{value} '
            },
            splitLine: {
              show: false
            }
          },
          {
            type: 'value',
            name: name[1],
            // min: Math.min.apply(null, dateListOne),
            max: Math.max.apply(null, dateListTow),
            axisLabel: {
              formatter: '{value}'
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [{
          name: name[0],
          type: 'bar',
          tooltip: {
            trigger: 'axis'
          },
          yAxisIndex: 0,
          data: dateListOne,
          // offset: 100
        },
        {
          name: name[1],
          type: 'line',
          tooltip: {
            trigger: 'axis'
          },
          yAxisIndex: 1,
          data: dateListTow,
          // offset: 30
        },
        ]
      });
    },
    // 导出报表
    onExportTable() {
      if (this.Lib.checkPower('beauty-4-dcygxsldfx') == false) return;
      const item = JSON.parse(window.sessionStorage.getItem('selectDate'));
      if (this.acitve == 0) {
        this.$root.$children[0].fatherExport('exportTechnicianSaleAnalyseMsg', item.beginTime, item.endTime, item.dateType);
      } else {
        this.$root.$children[0].fatherExport('exportTechnicianServeAnalyseMsg', item.beginTime, item.endTime, item.dateType);
      }
    },
    // 打印报表
    onPrint() {
      if (this.Lib.checkPower('beauty-4-dyygxsldfx') == false) return;
      if (this.acitve == 0) {
        console.log('销售');
        this.$print({
          data: this.tableData,
          table_tol: [
            {
              prop: 'technicianName',
              name: '员工名称'
            },
            {
              prop: 'packageSaleCount',
              name: '项目销售量'
            },
            {
              prop: 'productSaleCount',
              name: '产品销售量'
            },
            {
              prop: 'packageSaleCount',
              name: '套餐销售量'
            },

            {
              prop: 'saleCount',
              name: '累计销售量'
            },
            {
              prop: 'saleAmount',
              name: '累计销售总额'
            }
          ],
          title: '员工销售明细'
        });
      } else {
        this.$print({
          data: this.tableData,
          table_tol: [
            {
              prop: 'technicianName',
              name: '员工名称'
            },
            {
              prop: 'memberServeCount',
              name: '会员劳动次数（次）'
            },
            {
              prop: 'noMemberServeCount',
              name: '散客劳动次数（次）'
            },
            {
              prop: 'serveCount',
              name: '累计劳动次数（次）'
            },

            {
              prop: 'serveAmount',
              name: '累计劳动总额'
            },
          ],
          title: '员工劳动明细'
        });
      }
    },
    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      // 保存每页数据的函数
      const tableData = [];
      // pagesize=10 每页条数
      // 设置开始
      const start = 10 * val - 10;
      // 设置结束长度
      let end = 10 * val; // 长度判断 //所有分页数据 this.tableData
      const arrLength = this.acitve == 0 ? this.list.technicianSaleDetailList.length : this.list.technicianServeDetailList.length;
      const arr = this.acitve == 0 ? this.list.technicianSaleDetailList : this.list.technicianServeDetailList;
      end = end > arrLength ? arrLength : end;
      for (let i = start; i < end; i++) {
        // 所有分页数据 this.tableData
        tableData.push(arr[i]);
      }
      this.tableData = tableData;
    },
    // 获取数据
    initGetSignSuccess(e) {
      this.currentPage = 1;
      this.myChart = echarts.init(document.getElementById('barDate'));
      // 加载中
      const style = {
        text: '', // 加载时候的文本
      };
      this.myChart.showLoading(style);
      const data = {
        beginTime: e.beginTime,
        endTime: e.endTime,
        dateType: e.dateType,
        mainId: sessionStorage.getItem('mainId'),
      };
      if (this.acitve == 0) {
        api.getTechnicianSaleAnalyseMsg(data).then((res) => {
          if (res.code === 0) {
            this.list = res.data;
            this.tableData = res.data.technicianSaleDetailList;
            this.total = Object.keys(res.data.technicianSaleDetailList).length;
            this.drawProjectBar();
            this.handleCurrentChange(1);
            this.myChart.hideLoading();
          }
        });
      } else {
        api.getTechnicianServeAnalyseMsg(data).then((res) => {
          if (res.code === 0) {
            this.list = res.data;
            this.tableData = res.data.technicianServeDetailList;
            this.total = Object.keys(res.data.technicianServeDetailList).length;
            this.drawProjectBar();
            this.handleCurrentChange(1);
            this.myChart.hideLoading();
          }
        });
      }
    },
  },

};
</script>
<style lang="less" scoped>
.employeeSale{
  .employeeSale-top{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    ul{
      width: 140px;
      height: 38px;
      background-color: #ffffff;
      border-radius: 4px;
      border: solid 1px #d8dce5;
      text-align: center;
      li{
        display: inline-block;
        width: 70px;
        height: 38px;
        line-height: 38px;
        font-size: 14px;
        color: #5a5e66;
      }
    }
  }
  .bar-box{
    margin: 20px 0;
    padding: 30px;
    // overflow: hidden;
    // height: 340px;
    // height: 267px;
    background-color: #ffffff;
    border: solid 1px #ebeef5;
    overflow: auto;
    h2{
      font-size: 14px;
      color: #2d2f33;
      font-weight: 900;
    }
  }
  .employeeSale-table{
    position: relative;
    .button_group {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}
</style>
